import rulesData from './rules.json'

const rules = () => ({
    rules: rulesData
});

export default rules;